'use strict';
// https://github.com/tc39/proposal-global
require('../modules/esnext.global-this');
var globalThis = require('../internals/global-this');

module.exports = globalThis;
